import { render, staticRenderFns } from "./brick_generic_modelgenerator_subcomponent_probability_chart.vue?vue&type=template&id=1f63d242&"
import script from "./brick_generic_modelgenerator_subcomponent_probability_chart.vue?vue&type=script&lang=js&"
export * from "./brick_generic_modelgenerator_subcomponent_probability_chart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports